module.exports = __webpack_public_path__ + "static/media/step-3-provide-name-and-select-file.49cfc58d.png";